import { ItemProductCartButtonActions } from '../item-product-cart/item-product-cart.model';

export const UNAVAILABLE_ITEM = {
    text: 'dev.cart.wishlist.SeeDisponibility',
    id: 'unavailable',
};

export const WISH_ITEM_OPTIONS: ItemProductCartButtonActions[] = [
    {
        title: 'dev.product.addToShopCart',
        event: 'addToBag',
        category: 'services',
        image: 'shopping-bag',
        changeWithStock: true,
    },
    {
        title: 'dev.general.delete',
        event: 'deleteItem',
        category: 'actions',
        image: 'delete',
        changeWithStock: false,
    },
];
